export default "__VITE_ASSET__04308a25__"